"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.is");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toString = void 0;

var quote_1 = require("./quote");

var object_1 = require("./object");

var function_1 = require("./function");
/**
 * Stringify primitive values.
 */


var PRIMITIVE_TYPES = {
  string: quote_1.quoteString,
  number: function number(value) {
    return Object.is(value, -0) ? "-0" : String(value);
  },
  "boolean": String,
  symbol: function symbol(value, space, next) {
    var key = Symbol.keyFor(value);
    if (key !== undefined) return "Symbol.for(".concat(next(key), ")"); // ES2018 `Symbol.description`.

    return "Symbol(".concat(next(value.description), ")");
  },
  bigint: function bigint(value, space, next) {
    return "BigInt(".concat(next(String(value)), ")");
  },
  undefined: String,
  object: object_1.objectToString,
  "function": function_1.functionToString
};
/**
 * Stringify a value recursively.
 */

var toString = function toString(value, space, next, key) {
  if (value === null) return "null";
  return PRIMITIVE_TYPES[typeof value](value, space, next, key);
};

exports.toString = toString;